// @ts-nocheck
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { socket } from "../../../services/socket.io/socket.io.config";
import {
  JOIN_CHAT,
  ON_DELETE_MESSAGE_EVENT,
  ON_EDIT_MESSAGE_EVENT,
  ON_NEW_CHAT_ROOM,
  ON_NEW_MESSAGE_HANDLER,
} from "./constants";
import {
  ADD_NEW_CHAT_ROOM_PARTICIPANT,
  ON_DELETE_MESSAGE,
  ON_EDIT_MESSAGE,
  ON_NEW_MESSAGE_ONE_ON_ONE_CHAT,
} from "../../../store/constants/oneononemessaging";
import { markMessagesAsReadAction } from "../../../store/actions/oneOnOneMessagingActions";
import { ALERT_DIALOG } from "../../../store/constants/auth";
import {
  emitOneToOneMessagesDelivered,
  emitSocketEvent,
} from "../../../services/apiService";
import { useLocation } from "react-router-dom";
import _ from "lodash";

const useOneOnOneMessaging = ({
  // chatRoom,
  // chatRooms,
  showNewActivityBtnHandler,
  global = false,
}) => {
  // react-router hooks start...
  const location = useLocation();
  // react-router hooks end...

  // redux hooks start...
  const dispatch = useDispatch();

  // selectors start...
  const auth = useSelector((store) => store.auth);
  const { chatRoomMessages, selectedChatRoom, chatRooms } = useSelector(
    (store) => store.oneOnOneMessaging,
  );
  // selectors end...
  // redux hooks end...

  // Handlers start...
  // emit handlers start...
  const joinChatRoomsHandler = async ({ chatRoomIds }) => {
    const response = await emitSocketEvent({
      event: JOIN_CHAT,
      payload: {
        roomIds: chatRoomIds,
        token: auth?.userToken,
      },
    });

    if (response?.status === "failure") {
      // dispatch({
      //   type: ALERT_DIALOG,
      //   payload: {
      //     open: true,
      //     title: "Error!",
      //     message: "Some error occured in connecting to the server. Please reload the browser!"
      //   }
      // })
    }

    // socket.emit(JOIN_CHAT, {
    //   roomIds: chatRoomIds,
    //   token: auth?.userToken
    // }, (response) => {
    //   console.log(response, "JOIN_CHAT")
    //   if (response?.status === "failure") {
    //     dispatch({
    //       type: ALERT_DIALOG,
    //       payload: {
    //         open: true,
    //         title: "Error!",
    //         message: "Some error occured in connecting to the server. Please reload the browser!"
    //       }
    //     })
    //   }
    // });
  };

  // const deleteMessageEventHandler = ({
  //   messageId,
  //   roomId,
  //   successCallback
  // }) => {
  //   if (socket.connected) {
  //     socket.emit(DELETE_MESSAGE, {
  //       roomId,
  //       messageId,
  //       senderToken: auth?.userToken
  //     }, (response) => {
  //       console.log(response, "deleteMessageEventHandler");
  //       if (response?.status === "ok") {
  //         successCallback({
  //           res: response?.data?.data
  //         })
  //       } else {
  //         //
  //       }
  //     })
  //   }
  // }
  // emit handlers end...

  const onNewMessageHandler = (response) => {
    dispatch({
      type: ON_NEW_MESSAGE_ONE_ON_ONE_CHAT,
      payload: {
        auth,
        newMessage: response?.data,
      },
    });

    if (response?.success == true) {
      emitOneToOneMessagesDelivered({
        roomIds: _.isArray(response?.data)
          ? response?.data?.map((c) => ({ id: c?.chatId }))
          : [{ id: response?.data?.chatId }],
      });
    }

    if (response?.data?.chatId === selectedChatRoom?.data?._id) {
      if (showNewActivityBtnHandler) {
        showNewActivityBtnHandler();
      }
      dispatch(
        markMessagesAsReadAction({
          payload: {
            roomId: response?.data?.chatId,
          },
        }),
      );
    }
  };

  const onEditMessageHandler = (response) => {
    dispatch({
      type: ON_EDIT_MESSAGE,
      payload: {
        editedMessage: response?.data,
      },
    });
  };

  const onDeleteMessageHandler = (response) => {
    dispatch({
      type: ON_DELETE_MESSAGE,
      payload: {
        deletedMessage: response?.data,
      },
    });
    // if (chatRoomMessages?.data?.length === 0) {
    // dispatch(fetchLatestMessageInChatRoomAction({
    //   params: {
    //     chatId: response?.data?.chatId
    //   },
    //   successCallback: ({
    //     res
    //   }) => {
    //     dispatch({
    //       type: ON_DELETE_MESSAGE,
    //       payload: {
    //         deletedMessage: res?.data
    //       }
    //     });
    //   },
    //   failureCallback: ({
    //     error
    //   }) => {
    //     if (error?.status === 404) {
    //       dispatch({
    //         type: ON_DELETE_MESSAGE,
    //         payload: {
    //           deletedMessage: response?.data
    //         }
    //       });
    //     }
    //   }
    // }));
    // } else {
    //   dispatch({
    //     type: ON_DELETE_MESSAGE,
    //     payload: {
    //       deletedMessage: response?.data,
    //     }
    //   });
    // }

    // dispatch({
    //   type: ON_DELETE_MESSAGE,
    //   payload: {
    //     deletedMessage: response?.data,
    //   }
    // });
    // joinChatRoomsHandler({
    //   chatRoomIds: [response?.savedChat?._id]
    // })
  };

  const onNewChatRoomHandler = (response) => {
    dispatch({
      type: ADD_NEW_CHAT_ROOM_PARTICIPANT,
      payload: {
        newChatRoom: response,
        // newChatRoomFirstMessage: response?.messageData?.data
      },
    });
    // joinChatRoomsHandler({
    //   chatRoomIds: [response?.savedChat?._id]
    // })
  };
  // const sendNewMessageHandler = ({
  //   payload,
  //   successCallback
  // }) => {

  //   socket.emit(NEW_MESSAGE_HANDLER, {
  //     ...payload,
  //     senderToken: auth?.userToken,
  //     roomId: selectedChatRoom?.data?._id
  //   }, (payload) => {
  //     console.log("sendNewMessageHandlerAck", payload);
  //   });
  //   // successCallback ? successCallback({}) : null;
  // }
  // Handlers end...

  // useEffect start...
  // React.useEffect(() => {
  //   dispatch({
  //     type: SETUP_LOADING
  //   });
  //   socket.on("connect", () => {
  //     socket.emit(SETUP, {
  //       _id: auth?.userId
  //     }, (response) => {
  //       console.log("setup_response", response)
  //       if (response?.status === "ok") {
  //         dispatch({
  //           type: SETUP_SUCCESS
  //         });
  //       } else {
  //         dispatch({
  //           type: SETUP_FAILURE
  //         });
  //       }
  //     });
  //   });

  // }, []);

  React.useEffect(() => {
    if (!global || (global && location.pathname !== "/event/chat/admin")) {
      socket.on(ON_NEW_MESSAGE_HANDLER, onNewMessageHandler);
      socket.on(ON_NEW_CHAT_ROOM, onNewChatRoomHandler);
      socket.on(ON_EDIT_MESSAGE_EVENT, onEditMessageHandler);
      socket.on(ON_DELETE_MESSAGE_EVENT, onDeleteMessageHandler);
    } else {
      socket.off(ON_NEW_MESSAGE_HANDLER, onNewMessageHandler);
      socket.off(ON_NEW_CHAT_ROOM, onNewChatRoomHandler);
      socket.off(ON_EDIT_MESSAGE_EVENT, onEditMessageHandler);
      socket.off(ON_DELETE_MESSAGE_EVENT, onDeleteMessageHandler);
    }

    return () => {
      socket.off(ON_NEW_MESSAGE_HANDLER, onNewMessageHandler);
      socket.off(ON_NEW_CHAT_ROOM, onNewChatRoomHandler);
      socket.off(ON_EDIT_MESSAGE_EVENT, onEditMessageHandler);
      socket.off(ON_DELETE_MESSAGE_EVENT, onDeleteMessageHandler);
    };
  }, [selectedChatRoom, global, location]);

  React.useEffect(() => {
    if (global && location.pathname === "/event/chat/admin") {
      return;
    }

    if (chatRooms?.data?.length > 0) {
      joinChatRoomsHandler({
        chatRoomIds: chatRooms?.data?.map((chatRoom) => {
          return chatRoom?._id;
        }),
      });
    }
  }, [chatRooms?.data?.length, auth?.userToken, location, global]);
  // useEffect end...

  return {
    // sendNewMessageHandler
    // deleteMessageEventHandler
  };
};

export default useOneOnOneMessaging;